import { render, staticRenderFns } from "./FruechteBoxProductSelection.vue?vue&type=template&id=1376a153"
import script from "./FruechteBoxProductSelection.vue?vue&type=script&lang=ts"
export * from "./FruechteBoxProductSelection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports